import { Injectable } from '@angular/core';
import { color } from 'echarts';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  displayMessages: boolean = false;
  notifications: Notification[] = [];

  itemValue = new BehaviorSubject(this.notification);

  set notification(notif: Notification) {
    this.itemValue.next(notif);
    localStorage.setItem('notification', JSON.stringify(notif));
  }

  get notification() {
    return JSON.parse(localStorage.getItem('notification'));
  }

  constructor() {
    this.initNotifications();
  }

  private initNotifications() {
    /*this.notifications.push({icon: 'fas fa-user', text: 'testo prova 1', date: new Date(), read: false});
    this.notifications.push({icon: 'fas fa-user', text: 'testo prova 2', date: new Date(), read: false});
    this.notifications.push({icon: 'fas fa-user', text: 'testo prova 3', date: new Date(), read: false});
    this.notifications.push({icon: 'fas fa-user', text: 'testo prova 4', date: new Date(), read: false});
    this.notifications.push({icon: 'fas fa-user', text: 'testo prova 5', date: new Date(), read: false});
    this.notifications.push({icon: 'fas fa-user', text: 'testo prova 6', date: new Date(), read: false});
    this.notifications.push({icon: 'fas fa-user', text: 'testo prova 7', date: new Date(), read: false});
    this.notifications.push({icon: 'fas fa-user', text: 'testo prova 8', date: new Date(), read: false});
    this.notifications.push({icon: 'fas fa-user', text: 'testo prova 9', date: new Date(), read: false});*/
  }

  public addMessage(icon: string, text: string, color: string,bgcolor: string,  date: Date) {
    this.displayMessages = true;
  
    let bgc='';
    if(bgcolor=='uno'){
      bgc='#2099D8';
    }
    if(bgcolor=='due'){
      bgc='#33A1BF';
    }
    if(bgcolor=='tre'){
      bgc='#47A9A6';
    }
    if(bgcolor=='quattro'){
      bgc='#5BB18D';
    }
    if(bgcolor=='cinque'){
      bgc='#A70004';
    }
    if(bgcolor=='sei'){
      bgc='#EE5420';
    }  if(bgcolor=='sette'){
      bgc='#FDA833';
    }
    if(bgcolor=='otto'){
      bgc='#87CB76';
    }
    this.notifications.unshift({icon: icon, text: text, color: color, bgcolor: bgc, date: date, read:false});
    let notif: Notification = {
      icon: icon,
      text: text,
      color: color,
      bgcolor: bgc,
      date: date,
      read: false
    };
    this.playAudio();
  }

  playAudio(){
    let audio = new Audio();
    audio.src = "assets/audio/notification.wav";
    audio.load();
    audio.play();
   
  }

  public removeMessages() {
    this.notifications = [] as Notification[];
    this.displayMessages = false;
  }

  public removeMessage(message: Notification) {
    const index = this.notifications.indexOf(message, 0);
    if (index > -1) {
      this.notifications.splice(index, 1);
    }
  }

}

export interface Notification {
  
  icon: string;
  text: string;
  color: string;
  bgcolor: string;
  date: Date;
  read: boolean;

}
